const downloadBtnPdf = document.querySelector("#download-quote-pdf-btn");
downloadBtnPdf.addEventListener("click", (e) => {
  e.preventDefault();
  downloadBtnPdf.disabled = true;
  downloadBtnPdf.style.opacity = "0.5";
  downloadBtnPdf.classList.add('btn--loading');
  const urlParams = new URLSearchParams(window.location.search);
  const custId = urlParams.get("customerId");
  // console.log("draftOrders", custId);
  // const url = `${`https://adh-shopify.herokuapp.com/ext-api/customers`}/${custId}/draft-orders?shop=${`anthomdesignhouse.myshopify.com`}${""}`;
  const url = `${`https://utils.anthomdesignhouse.com/api/ext`}/${custId}/draft-orders?shop=${`anthomdesignhouse.myshopify.com`}${""}`;
  setTimeout(() => {
    fetch(url)
      .then((response) => response.json())
      .then((resp) => {
        // console.log(resp);
        const draftOrder = resp?.["draft_orders"]?.[0];
        const draftOrderId = draftOrder?.id?.split("/").pop();
        downloadBtnPdf.disabled = false;
        downloadBtnPdf.style.opacity = "1";
        // window.location.href = `https://customapp.anthomdesignhouse.com/Shaomin/adh-app-live/p/download/qoute/pdf?id=${draftOrderId}&shop=anthomdesignhouse.myshopify.com`;
        window.open(
          `https://utils.anthomdesignhouse.com/api/quote-pdf/Quote-${draftOrder.name?.replace('#', '')}?id=${draftOrderId}&shop=anthomdesignhouse.myshopify.com`,
          "_blank"
        );
        downloadBtnPdf.style.opacity = "";
        downloadBtnPdf.classList.remove('btn--loading');
        downloadBtnPdf.disabled = false;
      });
  }, 3000);
});
